import Franchise from '../containers/MarketplaceFeatureEdit/Franchise/Franchise';
import RamadanCampaign from '../containers/MarketplaceFeatureEdit/RamadanCampaign/RamadanCampaign';
import ProductFeed from '../containers/MarketplaceFeatureEdit/ProductFeed/ProductFeed';
import WalletAddon from '../containers/MarketplaceFeatureEdit/WalletAddon/WalletAddon';
import { MarketplaceFeatureKey } from '../types/marketplace';
import { IMarketplaceFeatureParams, MarketplaceFeatureType } from './../types/marketplace';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import { SCREENS } from '~/constants/screens';
import { Integrations } from '~/constants/integrations';

export const takerKnowledgeUrl = 'https://help.taker.io/portal/en/kb/taker/';

export const marketplaceFilterCrumbs: IPickerOption[] = [
  { label: 'all', value: 'all' },
  { label: 'marketing', value: MarketplaceFeatureType.Marketing },
  { label: 'menu', value: MarketplaceFeatureType.Menu },
  { label: 'delivery', value: MarketplaceFeatureType.Delivery },
  { label: 'txt_franchise', value: MarketplaceFeatureType.Franchise },
  { label: 'charity', value: MarketplaceFeatureType.Charity },
  { label: 'pos', value: MarketplaceFeatureType.Pos },
  { label: 'txt_payment', value: MarketplaceFeatureType.Payment },
  { label: 'ordering', value: MarketplaceFeatureType.Ordering },
  { label: 'Integrations', value: MarketplaceFeatureType.Integrations },
];

export const MarketplaceFeaturesParams: Record<MarketplaceFeatureKey, IMarketplaceFeatureParams> = {
  [MarketplaceFeatureKey.Foodics]: {
    name: 'foodics',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_INTEGRATION(Integrations.FOODICS), path: ['Settings', 'Integrations', 'foodics'] },
  },
  [MarketplaceFeatureKey.Marn]: {
    name: 'marn',
    extensionComponent: null,
    configLink: null,
  },
  [MarketplaceFeatureKey.GoogleMaps]: {
    name: 'google_maps',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_INTEGRATION(Integrations.GOOGLE_MAPS), path: ['Settings', 'Integrations', 'google_maps'] },
  },
  [MarketplaceFeatureKey.TakerConnect]: {
    name: 'takerconnect',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_INTEGRATION(Integrations.CONNECT), path: ['Settings', 'Integrations', 'taker_connect'] },
  },
  [MarketplaceFeatureKey.Checkout]: {
    name: 'checkout',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_INTEGRATION(Integrations.CHECKOUT), path: ['Settings', 'Integrations', 'checkout'] },
  },
  [MarketplaceFeatureKey.ApplePay]: {
    name: 'apple_pay',
    extensionComponent: null,
    configLink: null,
  },
  [MarketplaceFeatureKey.TakerGo]: {
    name: 'takergo',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_INTEGRATION(Integrations.TAKER_GO), path: ['Settings', 'Integrations', 'takergo'] },
  },
  [MarketplaceFeatureKey.GoogleTagManager]: {
    name: 'google_tag_manager',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_INTEGRATION(Integrations.GOOGLE_TAG_MANAGER), path: ['Settings', 'Integrations', 'google_tag_manager'] },
  },
  [MarketplaceFeatureKey.TakerThreeSixty]: {
    name: 'taker360',
    description: 't360_market',
    extensionComponent: null,
    configLink: {
      href: SCREENS.SETTINGS_INTEGRATION(Integrations.T360),
      path: ['Settings', 'Integrations', 'taker360'],
      options: {
        hideWhenDisabled: false,
        hideEnableToggle: true,
      },
    },
  },
  [MarketplaceFeatureKey.FeedUs]: {
    name: 'feedus',
    extensionComponent: null,
    configLink: null,
  },
  [MarketplaceFeatureKey.Sap]: {
    name: 'sap',
    extensionComponent: null,
    configLink: null,
  },
  [MarketplaceFeatureKey.Deliverect]: {
    name: 'deliverect',
    extensionComponent: null,
    configLink: null,
  },
  [MarketplaceFeatureKey.Fodo]: {
    name: 'fodo',
    extensionComponent: null,
    configLink: null,
  },
  [MarketplaceFeatureKey.Mobile]: {
    name: 'mobile',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_MOBILE(), path: ['Settings', 'consumer_channel_configuration'] },
  },
  [MarketplaceFeatureKey.Kiosks]: {
    name: 'kiosks',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_KIOSK(), path: ['Settings', 'consumer_channel_configuration'] },
  },
  [MarketplaceFeatureKey.Wallet]: {
    name: 'wallet',
    extensionComponent: WalletAddon,
    configLink: null,
  },
  [MarketplaceFeatureKey.Cashback]: {
    name: 'cashback',
    extensionComponent: null,
    configLink: { href: SCREENS.CASHBACK(), path: ['marketing', 'cashback'], options: { hideWhenDisabled: true } },
  },
  [MarketplaceFeatureKey.Ramadan]: {
    name: 'ramadan_campaign',
    extensionComponent: RamadanCampaign,
    configLink: null,
  },
  [MarketplaceFeatureKey.Franchise]: {
    name: 'franchise',
    extensionComponent: Franchise,
    configLink: { href: SCREENS.SETTINGS_ORDERS_FRANCHISE(), path: ['Settings', 'franchise'], options: { hideWhenDisabled: true } },
  },
  [MarketplaceFeatureKey.Curbside]: {
    name: 'curbside',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_NOTIFICATIONS_CURBSIDE(), path: ['Settings', 'notifications'], options: { hideWhenDisabled: true } },
  },
  [MarketplaceFeatureKey.ComboDeals]: {
    name: 'combo_deals',
    extensionComponent: null,
    configLink: { href: SCREENS.DEALS(), path: ['marketing'], options: { hideWhenDisabled: true } },
  },
  [MarketplaceFeatureKey.ComboMeal]: {
    name: 'combo',
    extensionComponent: null,
    configLink: { href: SCREENS.MEALS(), path: ['menu', 'combo_meal_tab'], options: { hideWhenDisabled: true } },
  },
  [MarketplaceFeatureKey.Emenu]: {
    name: 'emenu',
    extensionComponent: null,
    configLink: { href: null, path: ['branches', 'dine_in'] },
  },
  [MarketplaceFeatureKey.AdvancedPromocode]: {
    name: 'advanced_promocode',
    extensionComponent: null,
    configLink: null,
  },
  [MarketplaceFeatureKey.CrossSelling]: {
    name: 'cross_selling',
    extensionComponent: null,
    configLink: null,
  },
  [MarketplaceFeatureKey.PromoBanners]: {
    name: 'promo_banners',
    extensionComponent: null,
    configLink: { href: SCREENS.PROMOBANNERS(), path: ['marketing', 'promo_banners'], options: { hideWhenDisabled: true } },
  },
  [MarketplaceFeatureKey.ProductFeed]: {
    name: 'product_feed',
    extensionComponent: ProductFeed,
    configLink: null,
  },
  [MarketplaceFeatureKey.Webhook]: {
    name: 'webhook',
    extensionComponent: null,
    configLink: { href: SCREENS.SETTINGS_WEBHOOK(), path: ['Settings', 'webhook'], options: { hideWhenDisabled: true } },
  },
};
